import { IChannel, IDevice } from '@generated/graphql'

export const DEFAULT_CHECKED_DEVICE = [IDevice.Pc, IDevice.Mobile]

export const CHANNEL_MAP = {
  [IChannel.Searchad]: '네이버',
  [IChannel.Google]: '구글',
  [IChannel.Youtube]: '유투브',
}
